import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/auth/forgot-password/page.tsx");
